import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import { 
  CitiTransaction, 
  ExpenseEntry, 
  CategoryRule, 
  RuleMatchType, 
  BUSINESS_CATEGORIES,
  EXPENSE_COGS_TYPES
} from '../types';

// Map for storing merchant to category and Expense/COGS mappings
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const merchantMappings: Record<string, { category: string, expenseCOGS: string }> = {
  // Software and Subscriptions
  '1PASSWORD': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'ADOBE': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'APPLE.COM': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'APPLE.COM/BILL': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'BOARDEXPORT': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'ORAH APPS': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'CHATGPT': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'DROPBOX': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'FIGMA': { category: 'SaaS and Software', expenseCOGS: 'Website Project COGS' },
  'GITHUB': { category: 'SaaS and Software', expenseCOGS: 'Website Project COGS' },
  'GOOGLE': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'INVISIONAPP': { category: 'SaaS and Software', expenseCOGS: 'Website Project COGS' },
  'LOOM': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'MAILCHIMP': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'MICROSOFT': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'NOTION': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'OTTER': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'PADDLE.NET': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'PIXIESET': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'REMARKABLE': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'SLACK': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'SUPERMETRICS': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  'ZOOM': { category: 'SaaS and Software', expenseCOGS: 'Software Expense' },
  
  // Marketing & Social Media
  'ARTGRID': { category: 'Marketing and Advertising', expenseCOGS: 'SM COGS' },
  'CANVA': { category: 'Marketing and Advertising', expenseCOGS: 'SM COGS' },
  'COOKIEYES': { category: 'Marketing and Advertising', expenseCOGS: 'Advertising and Promotion' },
  'FACEBK': { category: 'Marketing and Advertising', expenseCOGS: 'Paid SM COGS' },
  'FB': { category: 'Marketing and Advertising', expenseCOGS: 'Paid SM COGS' },
  'FACEBOOK': { category: 'Marketing and Advertising', expenseCOGS: 'Paid SM COGS' },
  'GETMAGIC.COM': { category: 'Marketing and Advertising', expenseCOGS: 'SM COGS' },
  'HOOTSUITE': { category: 'Marketing and Advertising', expenseCOGS: 'SM COGS' },
  'LATER.COM': { category: 'Marketing and Advertising', expenseCOGS: 'SM COGS' },
  'MODASH': { category: 'Marketing and Advertising', expenseCOGS: 'SM COGS' },
  'NINJACAT': { category: 'Marketing and Advertising', expenseCOGS: 'Paid Media COGS' },
  'SQUARE': { category: 'Marketing and Advertising', expenseCOGS: 'Advertising and Promotion' },
  'SQUARESPACE': { category: 'Marketing and Advertising', expenseCOGS: 'Advertising and Promotion' },
  'TRELLO': { category: 'Marketing and Advertising', expenseCOGS: 'SM COGS' },
  
  // Production & Media
  'B&H': { category: 'Equipment', expenseCOGS: 'SM Production COGS' },
  'FRAME.IO': { category: 'Equipment', expenseCOGS: 'SM Production COGS' },
  'PRODUCTION': { category: 'Production', expenseCOGS: 'Production Expense' },
  
  // Web Development & Hosting
  'AWS': { category: 'Web Hosting', expenseCOGS: 'Hosting COGS' },
  'BUGHERD': { category: 'Web Development', expenseCOGS: 'Website Maintenance COGS' },
  'CPANEL': { category: 'Web Hosting', expenseCOGS: 'Hosting COGS' },
  'DNSIMPLE': { category: 'Web Hosting', expenseCOGS: 'Hosting COGS' },
  'HOTJAR': { category: 'Web Development', expenseCOGS: 'Website Maintenance COGS' },
  'HTML.TO.DESIGN': { category: 'Web Development', expenseCOGS: 'Website Project COGS' },
  'MYFONT': { category: 'Web Development', expenseCOGS: 'Website Project COGS' },
  'REPORTURI': { category: 'Web Development', expenseCOGS: 'Website Project COGS' },
  'SOLARWINDS': { category: 'Web Development', expenseCOGS: 'Website Project COGS' },
  'PINGDOM': { category: 'Web Development', expenseCOGS: 'Website Project COGS' },
  'THE EVENTS CALENDAR': { category: 'Web Development', expenseCOGS: 'Website Maintenance COGS' },
  'TRANSLATEPRESS': { category: 'Web Development', expenseCOGS: 'Website Project COGS' },
  
  // SEO & Business Development
  'SCREAMINGFROG': { category: 'SEO', expenseCOGS: 'SEO COGS' },
  'SEMRUSH': { category: 'SEO', expenseCOGS: 'SEO COGS' },
  'HUBSPOT': { category: 'Business Development', expenseCOGS: 'Business Development Expense' },
  'TYPEFORM': { category: 'Business Development', expenseCOGS: 'Business Development Expense' },
  'YEXT': { category: 'SEO', expenseCOGS: 'SEO COGS' },
  
  // Professional Services
  'BILL.COM': { category: 'Professional Services', expenseCOGS: 'Accounting Expense' },
  'EXPENSIFY': { category: 'Professional Services', expenseCOGS: 'Accounting Expense' },
  'LEGAL ZOOM': { category: 'Professional Services', expenseCOGS: 'Legal Expense' },
  'LEGALZOOM': { category: 'Professional Services', expenseCOGS: 'Legal Expense' },
  'QBOOKS': { category: 'Professional Services', expenseCOGS: 'Accounting Expense' },
  'QUICKBOOKS': { category: 'Professional Services', expenseCOGS: 'Accounting Expense' },
  
  // Office & Supplies
  'AMAZON': { category: 'Office Expenses', expenseCOGS: 'Office Expense' },
  'AMZN': { category: 'Office Expenses', expenseCOGS: 'Office Expense' },
  'EQUINOX': { category: 'Office Expenses', expenseCOGS: 'Office Expense' },
  'OFFICE': { category: 'Office Expenses', expenseCOGS: 'Office Expense' },
  'SPOTIFY': { category: 'Office Expenses', expenseCOGS: 'Office Expense' },
  
  // Hardware & Equipment
  'HARDWARE': { category: 'Equipment', expenseCOGS: 'Hardware Expense' },
  
  // Transportation & Travel
  'AIRFARE': { category: 'Travel', expenseCOGS: 'Airfare Expense' },
  'AMERICAN': { category: 'Travel', expenseCOGS: 'Airfare Expense' },
  'CAR RENTAL': { category: 'Travel', expenseCOGS: 'Local Transportation Expense' },
  'CURB': { category: 'Travel', expenseCOGS: 'Local Transportation Expense' },
  'FLIGHT': { category: 'Travel', expenseCOGS: 'Airfare Expense' },
  'HOTEL': { category: 'Travel', expenseCOGS: 'Hotel Expense' },
  'KENYA TRAVEL': { category: 'Travel', expenseCOGS: 'OOT Travel Expense' },
  'LYFT': { category: 'Travel', expenseCOGS: 'Local Transportation Expense' },
  'PARKING': { category: 'Travel', expenseCOGS: 'Local Transportation Expense' },
  'TAXI': { category: 'Travel', expenseCOGS: 'Local Transportation Expense' },
  'TRAIN': { category: 'Travel', expenseCOGS: 'Local Transportation Expense' },
  'TRAVEL INSURANCE': { category: 'Travel', expenseCOGS: 'OOT Travel Expense' },
  'UBER': { category: 'Travel', expenseCOGS: 'Local Transportation Expense' },
  
  // Meals & Entertainment
  'MEALS': { category: 'Meals and Entertainment', expenseCOGS: 'Meals Expense' },
  'RESTAURANT': { category: 'Meals and Entertainment', expenseCOGS: 'Meals Expense' },
  'DINING': { category: 'Meals and Entertainment', expenseCOGS: 'Meals Expense' },
  
  // Utilities & Services
  'GEICO': { category: 'Insurance', expenseCOGS: 'Car Insurance Expense' },
  'OPTIMUM': { category: 'Utilities', expenseCOGS: 'Cable & Internet Expense' },
  'SPAIN WORKSPACE': { category: 'Rent and Utilities', expenseCOGS: 'Rent Expense' },
  'TMOBILE': { category: 'Utilities', expenseCOGS: 'Telephone Expense' },
  
  // Shipping & Delivery
  'UPS': { category: 'Shipping', expenseCOGS: 'Postage & Delivery Expense' },
  'USPS': { category: 'Shipping', expenseCOGS: 'Postage & Delivery Expense' },
  
  // Professional Development
  'HBR': { category: 'Professional Development', expenseCOGS: 'Dues and Subscriptions' },
  'JUSTANSWER': { category: 'Professional Development', expenseCOGS: 'Professional Development Expense' },
  'UDEMY': { category: 'Professional Development', expenseCOGS: 'Professional Development Expense' },
  
  // Recruiting
  'LINKEDIN': { category: 'Recruiting', expenseCOGS: 'Recruiting Expense' },
  
  // Miscellaneous
  'CC FEE': { category: 'Bank Fees', expenseCOGS: 'Bank Service Charge Expense' },
  'CRAINS': { category: 'Research', expenseCOGS: 'Research & Development Expense' },
  'GIFT': { category: 'Gifts', expenseCOGS: 'Business Gifts Expense' },
  'UPWORK': { category: 'Freelance Services', expenseCOGS: 'Freelance COGS' }
};

// Function to parse CSV file
export const parseCSVFile = (file: File): Promise<CitiTransaction[]> => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        try {
          const transactions: CitiTransaction[] = results.data
            .filter((row: any) => row.Status && row.Date && (row.Debit || row.Credit))
            .map((row: any) => {
              // Create a standard CitiTransaction from CSV data
              return {
                Status: row.Status,
                Date: formatCitiDate(row.Date), // Format to YYYY-MM-DD
                Description: row.Description,
                Debit: row.Debit || '',
                Credit: row.Credit || '',
              };
            });
          resolve(transactions);
        } catch (error) {
          console.error('Error parsing CSV data:', error);
          reject(error);
        }
      },
      error: (error) => {
        console.error('Error parsing CSV file:', error);
        reject(error);
      }
    });
  });
};

// Function to format Citi date (MM/DD/YYYY) to ISO format (YYYY-MM-DD)
const formatCitiDate = (dateString: string): string => {
  if (!dateString) return '';
  
  try {
    const parts = dateString.split('/');
    if (parts.length === 3) {
      const month = parts[0].padStart(2, '0');
      const day = parts[1].padStart(2, '0');
      const year = parts[2];
      return `${year}-${month}-${day}`;
    }
    return dateString; // Return as-is if not in expected format
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateString;
  }
};

// Function to parse Excel file
export const parseExcelFile = (file: File): Promise<CitiTransaction[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const data = e.target?.result;
        if (!data) {
          reject(new Error('Failed to read file'));
          return;
        }
        
        const workbook = XLSX.read(data, { type: 'binary' });
        
        // Look for the "Through Nov" sheet specifically, which contains transaction data
        // If not found, use the first sheet
        const sheetName = workbook.SheetNames.includes('Through Nov') 
          ? 'Through Nov' 
          : workbook.SheetNames[0];
        
        const worksheet = workbook.Sheets[sheetName];
        
        // Convert to JSON with headers
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        
        // Map Excel format to CitiTransaction format
        const transactions: CitiTransaction[] = jsonData.map((row: any) => {
          return {
            Status: 'Cleared', // Default status
            Date: formatExcelDate(row.Date), // Format Excel date number to MM/DD/YYYY
            Description: row.Description || '',
            Debit: row.Debit?.toString() || '',
            Credit: row.Credit?.toString() || '',
            // Store Excel-specific categorization
            Category: row.Category || '',
            ExpenseCOGS: row['Expense/COGS'] || ''
          };
        });
        
        // Also try to extract categorization rules from the Category sheet if it exists
        if (workbook.SheetNames.includes('Category')) {
          try {
            const categoryWorksheet = workbook.Sheets['Category'];
            const categoryData = XLSX.utils.sheet_to_json(categoryWorksheet);
            
            // Process category mappings
            processCategoryMappings(categoryData);
          } catch (error) {
            console.error('Error processing Category sheet:', error);
          }
        }
        
        resolve(transactions);
      } catch (error) {
        reject(error);
      }
    };
    
    reader.onerror = (error) => reject(error);
    reader.readAsBinaryString(file);
  });
};

// Process category mappings from Excel's Category sheet
function processCategoryMappings(categoryData: any[]): void {
  categoryData.forEach(row => {
    const keys = Object.keys(row);
    if (keys.length >= 2) {
      const merchantKey = row[keys[0]];
      const category = row[keys[1]];
      
      if (merchantKey && category && typeof merchantKey === 'string') {
        // Use existing expenseCOGS if available, otherwise use category as both
        const expenseCOGS = merchantMappings[merchantKey]?.expenseCOGS || category;
        merchantMappings[merchantKey] = { category, expenseCOGS };
      }
    }
  });
}

// Helper function to format Excel date number to MM/DD/YYYY
function formatExcelDate(excelDate: any): string {
  if (!excelDate) return '';
  
  // Excel dates are stored as number of days since 1/1/1900
  // Convert to JavaScript date
  try {
    // If it's already a string, return as is
    if (typeof excelDate === 'string') return excelDate;
    
    const jsDate = new Date(Math.round((excelDate - 25569) * 86400 * 1000));
    const month = jsDate.getMonth() + 1; // getMonth() is zero-indexed
    const day = jsDate.getDate();
    const year = jsDate.getFullYear();
    
    return `${month}/${day}/${year}`;
  } catch (error) {
    console.error('Error formatting Excel date:', error);
    return excelDate.toString();
  }
}

// Function to detect if a file is Excel or CSV
export const detectFileType = (file: File): 'csv' | 'excel' | 'unknown' => {
  const fileName = file.name.toLowerCase();
  if (fileName.endsWith('.csv')) {
    return 'csv';
  } else if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls')) {
    return 'excel';
  }
  return 'unknown';
};

// Function to parse file based on type
export const parseFile = async (file: File): Promise<CitiTransaction[]> => {
  const fileType = detectFileType(file);
  
  switch (fileType) {
    case 'csv':
      return parseCSVFile(file);
    case 'excel':
      return parseExcelFile(file);
    default:
      throw new Error('Unsupported file type. Please upload a CSV or Excel file.');
  }
};

// Find business category and expense type based on merchant name
export const findMerchantMapping = (description: string): { category: string, expenseCOGS: string } => {
  // Check for exact matches in merchant mappings
  for (const [merchantKey, mapping] of Object.entries(merchantMappings)) {
    if (description.toUpperCase().includes(merchantKey.toUpperCase())) {
      return mapping;
    }
  }
  
  // Enhanced fallback category detection
  const descriptionUpper = description.toUpperCase();
  
  // Check for common keywords in description to provide better default categories
  if (descriptionUpper.includes('UBER') || descriptionUpper.includes('LYFT') || descriptionUpper.includes('TAXI')) {
    return { category: 'Travel', expenseCOGS: 'Local Transportation Expense' };
  }
  
  if (descriptionUpper.includes('HOTEL') || descriptionUpper.includes('AIRBNB') || descriptionUpper.includes('LODGING')) {
    return { category: 'Travel', expenseCOGS: 'Hotel Expense' };
  }
  
  if (descriptionUpper.includes('AIRLINES') || descriptionUpper.includes('AIR ') || descriptionUpper.includes('FLIGHT')) {
    return { category: 'Travel', expenseCOGS: 'Airfare Expense' };
  }
  
  if (descriptionUpper.includes('RESTAURANT') || descriptionUpper.includes('CAFE') || descriptionUpper.includes('COFFEE')) {
    return { category: 'Food & Dining', expenseCOGS: 'Meals Expense' };
  }
  
  if (descriptionUpper.includes('AWS') || descriptionUpper.includes('AMAZON WEB') || descriptionUpper.includes('DIGITALOCEAN')) {
    return { category: 'SaaS and Software', expenseCOGS: 'Hosting COGS' };
  }
  
  if (descriptionUpper.includes('DOMAIN') || descriptionUpper.includes('HOSTING') || descriptionUpper.includes('DNS')) {
    return { category: 'SaaS and Software', expenseCOGS: 'Hosting COGS' };
  }
  
  if (descriptionUpper.includes('OFFICE') || descriptionUpper.includes('SUPPLIES') || descriptionUpper.includes('STAPLES')) {
    return { category: 'Office Expenses', expenseCOGS: 'Office Expense' };
  }
  
  if (descriptionUpper.includes('SOFTWARE') || descriptionUpper.includes('LICENSE') || descriptionUpper.includes('SUBSCRIPTION')) {
    return { category: 'SaaS and Software', expenseCOGS: 'Software Expense' };
  }
  
  if (descriptionUpper.includes('LAWYER') || descriptionUpper.includes('LEGAL') || descriptionUpper.includes('ATTORNEY')) {
    return { category: 'Professional Services', expenseCOGS: 'Legal Expense' };
  }
  
  if (descriptionUpper.includes('ACCOUNTANT') || descriptionUpper.includes('ACCOUNTING') || descriptionUpper.includes('TAX PREP')) {
    return { category: 'Professional Services', expenseCOGS: 'Accounting Expense' };
  }
  
  if (descriptionUpper.includes('MARKETING') || descriptionUpper.includes('AD ') || descriptionUpper.includes('ADVERTISING')) {
    return { category: 'Marketing and Advertising', expenseCOGS: 'Advertising and Promotion' };
  }
  
  // Default values if no match found
  return { 
    category: 'Other', 
    expenseCOGS: 'General Expense' 
  };
};

// Function to categorize a transaction
export const categorizeTransaction = (
  transaction: CitiTransaction,
  rules: CategoryRule[]
): { category: string, expenseCOGS: string } => {
  const description = transaction.Description;
  
  // First check if there's a matching rule with both category and expenseCOGS
  for (const rule of rules) {
    if (matchesPattern(description, rule)) {
      if (rule.expenseCOGS) {
        return { 
          category: rule.category, 
          expenseCOGS: rule.expenseCOGS 
        };
      }
      
      // Rule has category but no expenseCOGS, try to find a matching expenseCOGS
      const mapping = findMerchantMapping(description);
      return { 
        category: rule.category, 
        expenseCOGS: mapping.expenseCOGS 
      };
    }
  }
  
  // If no rule matches, use merchant mapping
  return findMerchantMapping(description);
};

// Function to match a string against a rule pattern
const matchesPattern = (text: string, rule: CategoryRule): boolean => {
  const matchType = rule.matchType || RuleMatchType.CONTAINS;
  const caseSensitive = rule.caseSensitive || false;
  
  let testText = text;
  let testPattern = rule.pattern;
  
  if (!caseSensitive) {
    testText = text.toUpperCase();
    testPattern = rule.pattern.toUpperCase();
  }
  
  switch (matchType) {
    case RuleMatchType.CONTAINS:
      return testText.includes(testPattern);
    case RuleMatchType.EXACT:
      return testText === testPattern;
    case RuleMatchType.STARTS_WITH:
      return testText.startsWith(testPattern);
    case RuleMatchType.ENDS_WITH:
      return testText.endsWith(testPattern);
    case RuleMatchType.REGEX:
      try {
        const regex = new RegExp(rule.pattern, caseSensitive ? undefined : 'i');
        return regex.test(text);
      } catch (error) {
        console.error('Invalid regex pattern:', rule.pattern);
        return false;
      }
    default:
      return testText.includes(testPattern);
  }
};

// Function to transform Citi transactions to expense entries
export const transformTransactions = (
  transactions: CitiTransaction[],
  rules: CategoryRule[]
): ExpenseEntry[] => {
  // Filter out credit transactions (payments) and transform to ExpenseEntry format
  return transactions
    .filter(transaction => {
      // Skip transactions that are payments (have a Credit value but no Debit)
      return !(transaction.Credit && !transaction.Debit);
    })
    .map(transaction => {
      // Determine the amount (from Debit, or negative of Credit if it's a refund)
      let amount = 0;
      if (transaction.Debit) {
        amount = parseFloat(transaction.Debit.replace(/,/g, '')) || 0;
      } else if (transaction.Credit) {
        amount = -(parseFloat(transaction.Credit.replace(/,/g, '')) || 0); // Credit is negative (income)
      }

      // Extract month from the date (for pivot table grouping)
      const month = transaction.Date.substring(5, 7); // Get MM from YYYY-MM-DD

      // First try to apply category rules
      const categorization = categorizeTransaction(transaction, rules);
      
      // Use explicit Excel categories if available, otherwise use the categorization
      // NOTE: We prioritize any existing Categories over rule-based mapping
      let category = '';
      let expenseCOGS = '';
      
      if (transaction.Category && transaction.Category.trim() !== '') {
        category = transaction.Category;
      } else {
        category = categorization.category;
      }
      
      if (transaction.ExpenseCOGS && transaction.ExpenseCOGS.trim() !== '') {
        expenseCOGS = transaction.ExpenseCOGS;
      } else {
        expenseCOGS = categorization.expenseCOGS;
      }
      
      // Fallback to merchant mappings for empty categories
      if (!category || category === 'Other' || !expenseCOGS) {
        const merchantMapping = findMerchantMapping(transaction.Description);
        
        if (!category || category === 'Other') {
          category = merchantMapping.category;
        }
        
        if (!expenseCOGS) {
          expenseCOGS = merchantMapping.expenseCOGS;
        }
      }

      // Make sure we have a default category value
      if (!category) category = 'Other';
      if (!expenseCOGS) expenseCOGS = 'General Expense';

      // Create the ExpenseEntry
      return {
        date: transaction.Date,
        description: transaction.Description,
        amount: amount,
        category: category,
        expenseCOGS: expenseCOGS,
        notes: '',
        month: month, // Store month for pivot table grouping
      };
    });
};

// Function to convert expense entries to CSV
export const exportToCSV = (expenses: ExpenseEntry[]): string => {
  return Papa.unparse(expenses);
};

// Function to generate Excel file with same format as Expense.xlsx
export const generateExcelFile = (expenses: ExpenseEntry[], categories: string[]): Blob => {
  // Create a new workbook
  const wb = XLSX.utils.book_new();
  
  // Create the "Through Nov" sheet with detailed transactions
  // Format exactly like Expense.xlsx
  const transactionData = expenses.map(expense => ({
    Month: expense.month || expense.date.substring(5, 7), // Use pre-extracted month or get from date
    Date: formatDateForExcel(expense.date), // Format date as MM/DD/YYYY
    Description: expense.description,
    Debit: expense.amount > 0 ? expense.amount : '', // Only positive amounts in Debit
    Credit: expense.amount < 0 ? Math.abs(expense.amount) : '', // Only negative amounts (as positive) in Credit
    Category: expense.category,
    'Expense/COGS': expense.expenseCOGS
  }));
  
  const transactionWs = XLSX.utils.json_to_sheet(transactionData);
  XLSX.utils.book_append_sheet(wb, transactionWs, 'Through Nov');
  
  // Create pivot table by category and month, exactly like in Expense.xlsx
  const pivotData = createPivotTable(expenses);
  XLSX.utils.book_append_sheet(wb, pivotData, 'Summary');
  
  // Create the Category sheet with merchant mappings
  const categoryData = Object.entries(merchantMappings).map(([merchant, mapping]) => ({
    Merchant: merchant,
    Category: mapping.category,
    'Expense/COGS': mapping.expenseCOGS
  }));
  
  const categoryWs = XLSX.utils.json_to_sheet(categoryData);
  XLSX.utils.book_append_sheet(wb, categoryWs, 'Category');
  
  // Generate Excel file
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  
  // Create Blob from the generated array
  return new Blob([wbout], { type: 'application/octet-stream' });
};

// Format date from YYYY-MM-DD to MM/DD/YYYY for Excel export
const formatDateForExcel = (dateString: string): string => {
  if (!dateString) return '';
  
  try {
    const [year, month, day] = dateString.split('-');
    return `${month}/${day}/${year}`;
  } catch (error) {
    console.error('Error formatting date for Excel:', error);
    return dateString;
  }
};

// Create pivot table worksheet for Excel export
const createPivotTable = (expenses: ExpenseEntry[]): XLSX.WorkSheet => {
  // Group expenses by category and month
  const pivotData: Record<string, Record<string, number>> = {};
  
  // Get unique categories and months
  const categories = Array.from(new Set(expenses.map(e => e.category))).sort();
  const months = Array.from(new Set(expenses.map(e => {
    const monthNum = e.month || e.date.substring(5, 7);
    const year = e.date.substring(0, 4);
    return `${monthNum}/${year}`;
  }))).sort((a, b) => {
    // Sort months chronologically
    const [monthA, yearA] = a.split('/');
    const [monthB, yearB] = b.split('/');
    
    if (yearA !== yearB) return parseInt(yearA) - parseInt(yearB);
    return parseInt(monthA) - parseInt(monthB);
  });
  
  // Initialize data structure
  categories.forEach(category => {
    pivotData[category] = {};
    months.forEach(month => {
      pivotData[category][month] = 0;
    });
  });
  
  // Sum expenses by category and month
  expenses.forEach(expense => {
    const category = expense.category;
    const monthNum = expense.month || expense.date.substring(5, 7);
    const year = expense.date.substring(0, 4);
    const monthKey = `${monthNum}/${year}`;
    
    if (pivotData[category]) {
      pivotData[category][monthKey] = (pivotData[category][monthKey] || 0) + expense.amount;
    }
  });
  
  // Create worksheet data
  const wsData: (string | number)[][] = [];
  
  // Add header row with month labels
  const headerRow: (string | number)[] = ['Category'];
  months.forEach(month => {
    headerRow.push(month);
  });
  headerRow.push('Total');
  wsData.push(headerRow);
  
  // Add data rows for each category
  categories.forEach(category => {
    const row: (string | number)[] = [category];
    let categoryTotal = 0;
    
    months.forEach(month => {
      const amount = pivotData[category][month] || 0;
      row.push(amount);
      categoryTotal += amount;
    });
    
    row.push(categoryTotal); // Category total
    wsData.push(row);
  });
  
  // Add total row
  const totalRow: (string | number)[] = ['Total'];
  let grandTotal = 0;
  
  months.forEach(month => {
    let monthTotal = 0;
    categories.forEach(category => {
      monthTotal += pivotData[category][month] || 0;
    });
    totalRow.push(monthTotal);
    grandTotal += monthTotal;
  });
  
  totalRow.push(grandTotal);
  wsData.push(totalRow);
  
  // Create worksheet
  return XLSX.utils.aoa_to_sheet(wsData);
}; 